import { Offering } from '@arrived/models';

import { OfferingTermsDetail } from './OfferingTermsDetailsList';

export interface OfferingTermsDetailDerivation extends Omit<OfferingTermsDetail, 'value'> {
  valueFn: (offering: Offering) => number | undefined;
}

export const PROPERTY_COSTS_DETAILS: OfferingTermsDetailDerivation[] = [
  {
    isMonetaryValue: true,
    valueFn: (offering) => offering.totalPurchasePrice,
    text: {
      id: 'property-purchase-price',
      defaultMessage: 'Property Purchase Price',
    },
    tooltipProps: {
      id: 'property-purchase-price-tooltip',
      defaultMessage:
        'The price paid to acquire the property. This does not include the offering fees or cash reserve.',
    },
  },
  {
    isMonetaryValue: true,
    valueFn: (offering) => offering.propertyImprovementsAndCashReserves,
    text: {
      id: 'property-improvements-cash-reserves',
      defaultMessage: 'Property Improvements & Cash Reserves',
    },
    tooltipProps: {
      id: 'property-improvements-cash-reserves-tooltip',
      defaultMessage:
        'The amount of money set aside for improvements to the property and a cash reserve balance for supporting long-term operations.',
    },
  },
  {
    isMonetaryValue: true,
    valueFn: (offering) => offering.closingOfferingAndHoldingCosts,
    text: {
      id: 'closing-offering-holding-costs',
      defaultMessage: 'Closing Costs, Offering Costs & Holding Costs',
    },
    tooltipProps: {
      id: 'closing-offering-holding-costs-tooltip',
      defaultMessage:
        'These expenses include the costs associated with closing on the property, offering the shares for investment, and financing the property alongside or after closing.',
    },
  },
  {
    isMonetaryValue: true,
    valueFn: (offering) => offering.arrivedOneTimeProceeds,
    text: {
      id: 'arrived-sourcing-fee',
      defaultMessage: 'Arrived Sourcing Fee (One-time)',
    },
    tooltipProps: {
      id: 'arrived-service-fee-tooltip',
      defaultMessage:
        'This is the fee Arrived charges for our work involved with sourcing the property and preparing it for investment. It’s a one-time fee that is already included in the Equity Raise from Investors and share price.',
    },
  },
];

export const SHARES_DETAILS: OfferingTermsDetailDerivation[] = [
  {
    isMonetaryValue: true,
    // TODO: This needs to be using a field from the Offering object, however, sharePrice is currently a calculated
    //  value and will change after the IPO of the Offering. For now, setting $10 as default since all Offerings have
    //  an IPO share price of $10
    //  See https://arrivedhomes.atlassian.net/browse/AT-1346
    valueFn: () => 10,
    text: {
      id: 'offering-share-price',
      defaultMessage: 'IPO Price Per Share',
    },
    tooltipProps: {
      id: 'offering-share-price-tooltip',
      defaultMessage: 'The price per share at the first time of sale to investors.',
    },
  },
  {
    valueFn: (offering) => offering.totalShares,
    text: {
      id: 'property-total-shares',
      defaultMessage: 'Total Shares',
    },
    tooltipProps: {
      id: 'property-total-shares-tooltip',
      defaultMessage: 'The total number of shares being offered to investors.',
    },
  },
];
